<div
	*clientScreen="let isDesktop = isDesktop"
	class="legacy-container scrollbar-fade overflow-auto"
	(click)="stopEvent($event)"
>
	<ng-content></ng-content>
</div>
